export type Deferred<T = any> = Promise<T> &
  Record<'resolve' | 'reject', (v: any) => void>;

function createDeferred<T>(): Deferred<T> {
  let resolve = null;
  let reject = null;
  const promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  Object.assign(promise, { resolve, reject });
  return promise as unknown as Deferred<T>;
}

export { createDeferred };
